$(document).ready(function () {
  $('a[target="_blank"][rel~="noopener"]').addClass('link');
});

// 最初と最後のページネーションの矢印を表示
jQuery(document).ready(function ($) {
  var prevButton = $('<span class="page-numbers prev disabled"></span>');
  var nextButton = $('<span class="page-numbers next disabled"></span>');
  var firstPageLink = $('.nav-links .page-numbers').first();
  var lastPageLink = $('.nav-links .page-numbers').last();

  if (firstPageLink.hasClass('current') && firstPageLink.text() === '1') {
    firstPageLink.before(prevButton);
  }
  if (lastPageLink.hasClass('current')) {
    lastPageLink.after(nextButton);
  }
});